import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import TabContext from "@mui/lab/TabContext";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import {
  getPodcastList,
  getPodcastLearners,
  updatePodcast,
  moveUprovedBroadcast,
  removeBroadcastAudio,
} from "./Services";
import { getRolesBySiteUuid, getUsersByRoleId } from "../Users/Services";
import { flattenDepth, find, map, findIndex } from "lodash";
import { joinByKeys, getClassNames } from "../../Js/Common";
import PodcastListComponent from "./PodcastListComponent";
import Confirmation from "../../Components/Modal/Confirmation";
import { getBroadCastFolderDates } from "../../Js/TimeAndDate";
import { getSettingsRecord } from "../Podcast/Services";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
 
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

const AllPodcast = () => {
  const navigation = useNavigate();
  const classes = useStyles();

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const [podcastList, setPodcastList] = useState([]);
  const [alias, setAlias] = useState();

  useEffect(() => {
    let aliasname = userInfo.username.split("@");
    setAlias(aliasname[aliasname.length - 1]);
  }, [userInfo]);

  useEffect(() => {
    initialDataLoad();
  }, []);

  const initialDataLoad = async () => {
    let categoryArr = [];
    if (
      userInfo &&
      userInfo.rolesInfo &&
      userInfo.rolesInfo.title.toLowerCase() == "learner"
    ) {
      let getCategoryOfYourClass = await getSettingsRecord(userInfo.site_uuid);
      if (getCategoryOfYourClass?.data?.data.length > 0) {
        getCategoryOfYourClass?.data?.data[0]?.keydata.forEach((val, index) => {
          if (findIndex(val.classes, { id: userInfo.belongs_to }) > -1) {
            categoryArr.push(val.value);
          }
        });
      }
    } else {
      categoryArr = [0, 1, 2];
    }
    let podcastListRes = await getPodcastList(userInfo.site_uuid, categoryArr);
    podcastListRes = podcastListRes.data;
    console.log("podcastListRes", podcastListRes);
    let allLearners = podcastListRes.data.map((val) => {
      return val.context.user_uuid;
    });
    allLearners = flattenDepth(allLearners, 1);
    const getAllLearnersNames = await getPodcastLearners(
      allLearners,
      userInfo.site_uuid,
      [true, false]
    );
    let withNames = podcastListRes.data.map((val) => {
      let names = val.context.user_uuid.map((val1) => {
        return joinByKeys(
          find(getAllLearnersNames.data, { uid: val1 }).name,
          ["firstname", "lastname"],
          " "
        );
      });

      return {
        ...val,
        renderStr:
          names.length > 2
            ? `${names.slice(0, 2).join(", ")} & ${names.slice(2).length} more `
            : names.join(", "),
        learners: names,
        folderDate: getBroadCastFolderDates(val.updatedAt),
      };
    });
    console.log("withNameswithNameswithNameswithNames", withNames);
    setPodcastList(withNames);
  };

  return (
    <Grid container>
      {/* <Grid item xs={12} sx={{ flex: 1 }}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            px: 6,
          }}
        >
          <Grid>
            <Box>
              <Search
                style={{
                  backgroundColor: "#F5F5F5",
                  borderRadius: 20,
                  width: "20rem",
                }}
              >
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                />
              </Search>
            </Box>
          </Grid>
          <Grid>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#F5F5F5",
                ml: 2,
                color: "#DB8829",
                borderRadius: 20,
                fontSize: "0.9rem",
                fontWeight: "600",
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Grid> */}
      <Grid xs={12} sx={{}}>
        <Box
          sx={{
            height: "67vh",
            overflow: "auto",
          }}
           
        >
          {podcastList && (
            <PodcastListComponent
              podcastList={podcastList}
              withApproval={false}
            ></PodcastListComponent>
          )}
        </Box>
        {/* <Confirmation
          image="assign"
          primaryText="Approval"
          secondaryText="Once you approve this podcast it will be available for all learners, are you sure?"
          visible={confirmModal}
          positiveClick={() => {
            saveAndUpdate();
          }}
          negativeClick={() => {
            setConfirmModal(false);
          }}
          toggleModal={(flag) => setConfirmModal(flag)}
          persistent={true}
        ></Confirmation> */}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AllPodcast;
